import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LottieComponent, provideLottieOptions } from 'ngx-lottie';
import player, { LottiePlayer } from 'lottie-web';
import { SpinnerComponent } from '@nimbus-library/features/shared/components/spinner/spinner.component';
import { InlineCircleSpinnerComponent } from '@nimbus-library/features/shared/components/spinner/inline-circle-spinner.component';

export function playerFactory(): LottiePlayer {
  return player;
}
@NgModule({
  imports: [CommonModule, LottieComponent],
  providers: [
    provideLottieOptions({
      player: playerFactory,
    }),
  ],
  declarations: [SpinnerComponent, InlineCircleSpinnerComponent],
  exports: [SpinnerComponent, InlineCircleSpinnerComponent],
})
export class SpinnerModule {}
